import { StateCreator } from 'zustand'
import { Settings, Store } from '../types'

export interface SettingsSlice {
  settings: Settings
  stores: Store[]
  monthlyBudget: number
  seeded: boolean
  updateSettings: (newSettings: Partial<Settings>) => void
  addStore: (store: Store) => void
  updateStore: (id: string, updatedStore: Partial<Store>) => void
  removeStore: (id: string) => void
  setStores: (stores: Store[]) => void
  setMonthlyBudget: (budget: number) => void
  setSeeded: (value: boolean) => void
  setOnboardingCompleted: (value: boolean) => void
}

const defaultSettings: Settings = {
  notifications: {
    pushEnabled: true,
    dealAlerts: true,
    lowStockWarnings: true,
  },
  onboardingCompleted: false,
  demoDealsVersion: 0,
  householdSize: 2,
  dietaryPreferences: [],
}

export const createSettingsSlice: StateCreator<SettingsSlice> = (set) => ({
  settings: defaultSettings,
  stores: [],
  monthlyBudget: 400,
  seeded: false,
  updateSettings: (newSettings) =>
    set((state) => ({ settings: { ...state.settings, ...newSettings } })),
  addStore: (store) => set((state) => ({ stores: [...state.stores, store] })),
  updateStore: (id, updatedStore) =>
    set((state) => ({
      stores: state.stores.map((store) =>
        store.id === id ? { ...store, ...updatedStore } : store,
      ),
    })),
  removeStore: (id) =>
    set((state) => ({
      stores: state.stores.filter((store) => store.id !== id),
    })),
  setStores: (stores) => set({ stores }),
  setMonthlyBudget: (budget) => set({ monthlyBudget: budget }),
  setSeeded: (value) => set({ seeded: value }),
  setOnboardingCompleted: (value) =>
    set((state) => ({
      settings: { ...state.settings, onboardingCompleted: value },
    })),
})
